import React from 'react';
import { useParams } from 'react-router';

import { RouterLinkButton } from '@/components/Button/RouterLinkButton';
import { ButtonList } from '@/components/Button/ButtonList';
import { useLearningJourneyBreadcrumbs } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';
import { slugify } from '@/utils/misc';
import { ROUTE_PATH } from '@/constants/routePaths';

export const BackToJourneyButton = ({ isProduct }: { isProduct?: boolean }): JSX.Element | null => {
  const { id } = useParams<{ id: string }>();
  const parsedLearningId = id ? parseInt(id) : NaN;

  const learningJourneyBreadcrumbs = useLearningJourneyBreadcrumbs({
    id: parsedLearningId,
    isProduct,
  });

  const href = learningJourneyBreadcrumbs?.parentSectionId
    ? `${ROUTE_PATH.JOURNEY_BASE}/${learningJourneyBreadcrumbs?.journeyId}/${slugify(learningJourneyBreadcrumbs?.journeyTitle)}/section/${
        learningJourneyBreadcrumbs?.parentSectionId
      }`
    : `${ROUTE_PATH.JOURNEY_BASE}/${learningJourneyBreadcrumbs?.journeyId}/${slugify(learningJourneyBreadcrumbs?.journeyTitle)}`;

  return learningJourneyBreadcrumbs?.journeyId && learningJourneyBreadcrumbs?.journeyTitle ? (
    <ButtonList>
      <RouterLinkButton to={href} $type="link" $iconPosition="left" $icon="long-arrow-alt-left">
        {'Back to journey'}
      </RouterLinkButton>
    </ButtonList>
  ) : null;
};
